// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectAssetClassTypesQueryResult, selectAssetClassTypesPageLoading, selectAssetClassTypesShowInitWaitingMessage} from '../_selectors/asset-class-type.selectors';

export class AssetClassTypesDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectAssetClassTypesPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectAssetClassTypesShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectAssetClassTypesQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
